const pad = (n: number) => (n > 9 ? `${n}` : ` ${n}`)

const timeSlot = (idx: number) => {
  const q = Math.floor(idx / 2)
  const r = idx % 2
  return `${pad(q)}:${r === 0 ? "00" : "30"} -- ${pad(r === 0 ? q : q + 1)}:${r === 0 ? "30" : "00"}`
}

export { timeSlot }
